export default __webpack_public_path__ + "db96f4ea06054d380ef86df33d9f7838.svg";